import React from 'react'

export default function MaterialItem(props) {
    function getFilePathExtension(path) {
        var filename = path.split('\\').pop().split('/').pop();
        var lastIndex = filename.lastIndexOf(".");
        if (lastIndex < 1) return "";
        return filename.substr(lastIndex + 1);
    }
    function renderIcon(){
        if(getFilePathExtension(props.fileName) == 'pptx' || getFilePathExtension(props.fileName) == 'ppt'){
            return <i class="far fa-file-powerpoint"></i>
        }else if(getFilePathExtension(props.fileName) == 'docx' || getFilePathExtension(props.fileName) == 'doc'){
            return <i class="far fa-file-word"></i>
        }else if(getFilePathExtension(props.fileName) == 'xls' || getFilePathExtension(props.fileName) == 'xlsx'){
            return <i class="far fa-file-word"></i>
        }else if(getFilePathExtension(props.fileName) == 'xls' || getFilePathExtension(props.fileName) == 'xlsx'){
            return <i class="far fa-file-excel"></i>
        }else if(getFilePathExtension(props.fileName) == 'zip' || getFilePathExtension(props.fileName) == 'rar'|| getFilePathExtension(props.fileName) == '7z'){
            return <i class="far fa-file-archive"></i>
        }else if(getFilePathExtension(props.fileName) == 'pdf'){
            return <i class="far fa-file-pdf"></i>
        }else{
            return <i class="far fa-file"></i>;

        }
            
     }

    const download = (event)=>
    {
        window.open(`https://community.aast.edu/elearning/DownloadFile.aspx?fileID=${props.fileID}&fileName=${props.fileName}`)
        event.preventDefault()
    } 
    return (
        <div class="col-4 col-md-4 col-sm-12">
            
            <div class="note note-info">
            <a  onClick={download} href="#" class="note-fileItem">
                <div class="note-icon">
                
                { renderIcon() }
                    
                    
                    </div>
                <div class="note-content">
                    <h4 class="text-ellipsis"><b>{props.itemName}</b></h4>
                    <p class="text-ellipsis"> {props.fileName} </p>
                </div>
                </a>
            </div>
            
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/pages/course/E-Learning/MaterialItem.js